/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect, useMemo } from 'react';

import { Product } from 'libs/http/api/content/content.types';
import { useRouter } from 'libs/router/useRouter';

import { STATIC_PRODUCTS } from 'features/product-pricing/organisms/PricingCards/data';

export const useProducts = (redirect: () => Promise<boolean>) => {
  const {
    query: {
      public_country: publicCountry,
      public_title: publicTitle,
      public_has_frequency_switcher: publicHasFrequencySwitcher = true,
      public_video: publicVideo,
      public_cta_type: publicCtaType,
      public_cta_text: publicCtaText,
      public_cta_link: publicCtaLink,
      public_presentation_id: publicPresentationId,
      public_included_block: publicIncludedBlock,
      public_included_block_type: publicIncludedBlockType,
    },
  } = useRouter();

  const data: Product[] | null = useMemo(() => {
    if (typeof publicCountry !== 'string') {
      return null;
    }

    return STATIC_PRODUCTS[publicCountry] ?? null;
  }, [publicCountry]);

  useEffect(() => {
    if (data === null || data.length === 0) {
      redirect();
    }
  }, [data, redirect]);

  return {
    data: data ?? [],
    setData: () => {},
    loading: false,
    setLoading: () => {},

    iframeData: useMemo(
      () => ({
        title: publicTitle,
        country: publicCountry,
        hasFrequencySwitcher: publicHasFrequencySwitcher !== 'false',
        video: typeof publicVideo === 'string' ? publicVideo : undefined,
        ctaType: typeof publicCtaType === 'string' ? publicCtaType : undefined,
        ctaText: typeof publicCtaText === 'string' ? publicCtaText : undefined,
        ctaLink: typeof publicCtaLink === 'string' ? publicCtaLink : undefined,
        presentationId: typeof publicPresentationId === 'string' ? publicPresentationId : undefined,
        includedBlock: typeof publicIncludedBlock === 'string' ? publicIncludedBlock : undefined,
        includedBlockType: typeof publicIncludedBlockType === 'string' ? publicIncludedBlockType : undefined,
      }),
      [
        publicCountry,
        publicCtaLink,
        publicCtaText,
        publicCtaType,
        publicHasFrequencySwitcher,
        publicPresentationId,
        publicTitle,
        publicVideo,
        publicIncludedBlock,
        publicIncludedBlockType,
      ],
    ),
  };
};
